import { gql } from "@apollo/client"

const GET_TIMETABLE_BOOKED_SLOT_DETAILS = gql`
  query($input: SessionTimetableBookedSlotDetailsInput!) {
    sessionTimetableBookedSlotDetails(input: $input) {
      id
      booked_by
      date_booked
      ends_at
      group
      guardian
      lesson
      meeting_type
      meeting_type_code
      starts_at
      status
      student
      subject
      booking_id
      slot_id
    }
  }
`

export { GET_TIMETABLE_BOOKED_SLOT_DETAILS }